import { SM } from "constants/sizes";
export default {
    title: `Trusted by <monday-paying-companies />+ customers worldwide`,
    titleSize: SM,
    padding: "0 32px",
    textAlign: "center"
};
